import { DayOfWeek } from '@/shared/models/common';
import { AvailabilityLevel } from './common';

export default class Availability {
  dayOfWeek: DayOfWeek = 0;
  isClosed = false;
  availabilityLevel: AvailabilityLevel | null = null;
}
